import { withInstall } from '@/utils'
import BusinessSelect from './src/businessSelect.vue'
export default withInstall(BusinessSelect)
